'use strict';

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const getTextWidth=require('../../../../../dist-es6/client/utilities/getTextWidth');
const Formatters=require('../../../../../dist-es6/client/formatters');
const SortExtensions=require('../../../../../dist-es6/client/extensions/sortExtensions');
const PersonStatisticsViewModel=require('../../../../../dist-es6/client/viewModels/personStatisticsViewModel');
const HeatmapGroupViewModel=require('../../../../../dist-es6/client/viewModels/heatmapGroupViewModel');
const PseudoGroup=require('../../../../../dist-es6/client/domain/pseudoGroup');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');


const DirectGroupHeaderHeight=35;
const SubGroupHeaderHeight=17;
const DefaultDirectGroupMargin=10;
const DefaultPersonHeight=21;
const MinPersonHeight=6;
const DefaultPersonWidth=160;
const MinPersonWidth=6;
const DefaultPersonAreaPaddingTop=5;
const TopLevelGroupHorizontalPadding=8;
const DefaultPersonHorizontalSpacing=6;
const DefaultPersonVerticalSpacing=6;
const BreadcrumbsHeight=40;
const TooltipWidth=186;

const MinMacroModePersonHeight=1;
const MinMacroModeGroupHeight=4;

const TopLevelHeaderFont='normal normal normal normal 18px "Roboto"';
const SubHeaderFont='normal normal normal normal 12px "Roboto"';
const PersonFont='normal normal normal normal 12px "Roboto"';

const MinimumTopLevelWidthToDisplayLargeNames=getTextWidth('MMM',TopLevelHeaderFont);
const MinimumPersonWidthToDisplayNames=getTextWidth('MM',PersonFont);
const MinimumPersonHeightToDisplayNames=10;let

DashboardHeatmapDirective=class DashboardHeatmapDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'dashboardDataService',
'searchQuery',
'filteredPersons',
'sortByFatigueScore',
'sortByFatigueAlertType',
'groupTree',
'selectedGroupData',
'selectedNotificationType'];

}

get templateUrl(){
return'/templates/features/dashboard/components/dashboardHeatmapView';
}

get controller(){
return DashboardHeatmapController;
}};let



DashboardHeatmapController=class DashboardHeatmapController{
static get $inject(){
return['$element','$scope','$timeout','elementService','heatmapService','displaySettingsService','groupTreeService'];
}

constructor($element,$scope,$timeout,elementService,heatmapService,displaySettingsService,groupTreeService){
this._$element=$element;
this._$scope=$scope;
this._$timeout=$timeout;
this._elementService=elementService;
this._heatmapService=heatmapService;
this._displaySettingsService=displaySettingsService;
this._groupTreeService=groupTreeService;

this._heatmapViewModel=null;
this._previousSelectedGroup=null;

this.isInitiallyLoading=!0;
this.groupHoverState=null;

this.useShortTopLevelNames=!1;
this.useShortGroupNames=!1;
this.useShortPersonNames=!1;
this.hidePersonNames=!1;
this.shrinkTopLevelNames=!1;

this.isMacroMode=!1;
this.isUsingFilteredPersons=!1;
this.macroModeGroupInfo=[];

this._personUnitWidth=DefaultPersonWidth;
this._singlePersonStyle={width:DefaultPersonWidth,height:DefaultPersonHeight};
this._heatmapDimensions={};

this.breadcrumbs=[];

this._memoizedHeatmapShortName=_.memoize(Formatters.heatmapShortName);

this._$scope.$on('resize::resize',()=>this._recalculateDimensions());

$scope.$watch('controller.selectedGroupData',(newGroup,oldGroup)=>{
if(_.exists(newGroup)&&newGroup===oldGroup){
return;
}
this._updateHeatmapViewModel();
});
$scope.$watch('controller.selectedNotificationType',(newType,oldType)=>{
if(_.exists(newType)&&newType===oldType){
return;
}
this._updateGroupThresholdStatusBars();
});
$scope.$watch('controller.filteredPersons',(newFilteredPersons,oldFilteredPersons)=>{
if(!_.exists(newFilteredPersons)||newFilteredPersons===oldFilteredPersons){
return;
}
this._filteredPersonIds=_.map(newFilteredPersons,'id');
this._$timeout(()=>{

this._recalculateDimensions();
});
});

this.sortByDecendingFatigueAlertTypeAndScore=[
SortExtensions(this.sortByFatigueAlertType).invert(),
SortExtensions(this.sortByFatigueScore).invert(),
'name'];


this._$timeout(()=>{

this._updateHeatmapViewModel();
});
}

selectSourceGroupById(id){
if(id===void 0||id===this.selectedGroupData.id){
return;
}

this._groupTreeService.selectGroupWithId(id);
}

_updateBreadcrumbs(){
if(this._lastBreadcrumbSelectedGroup===this.selectedGroupData&&this._lastBreadcrumbOrgVM===this._orgHeatmapViewModel){
return;
}
this.breadcrumbs=this._heatmapService.getGroupBreadcrumbs(this.selectedGroupData,this._orgHeatmapViewModel);
this._lastBreadcrumbSelectedGroup=this.selectedGroupData;
this._lastBreadcrumbOrgVM=this._orgHeatmapViewModel;
}

getPersonThresholdClasses(person){
return Formatters.classFromThresholdStatus(person.thresholdStatusFor(this.selectedNotificationType));
}

getThresholdClassString(person){
const classes=this.getPersonThresholdClasses(person);
let useClasses=[];
for(const className of _.keys(classes)){
if(classes[className]){useClasses.push(className)}
}

return useClasses.join(' ');
}

getPersonClasses(person){
return _.assign({
found:_.exists(this._filteredPersonIds)&&
this._filteredPersonIds.length!==this._orgHeatmapViewModel.aggregatePersons.length?
this._filteredPersonIds.length>0&&this._filteredPersonIds.includes(person.id):!0},

this.getPersonThresholdClasses(person));
}

getFatigueScore(person){
return Formatters.formatFatigue(_.get(person,'lastKnownStatus.fatigue'));
}

_updateHeatmapViewModel(){
if(!_.exists(this.selectedGroupData)||this.selectedGroupData===this._previousSelectedGroup){
return;
}
this._previousSelectedGroup=this.selectedGroupData;

let group=this.selectedGroupData;

if(!_.exists(this._orgHeatmapViewModel)||this._orgHeatmapViewModelFetchTime!==this._lastFetchTime){

const[[orgGroup],children]=_.partition(this.groupTree,g=>g.id===null);
this._orgHeatmapViewModel=HeatmapGroupViewModel.cloneFromGroupStatisticsViewModel(orgGroup);
this._orgHeatmapViewModel.children=children;
this._orgHeatmapViewModelFetchTime=this._lastFetchTime;
this._memoizedViewModelBuilder=_.memoize(g=>this._heatmapService.constructHeatmapViewModelTree(g));
}

if(this.selectedGroupData.id===null){
group=this._orgHeatmapViewModel;
}

this._heatmapViewModel=this._memoizedViewModelBuilder(group);

this._directGroups=_.sortBy(this._heatmapViewModel.children.length>0?
this._heatmapViewModel.children:
[this._heatmapViewModel],g=>g instanceof PseudoGroup?0:g.name);

this._recalculateDimensions();
}

get _personsTilesAreVisible(){
return!this.isMacroMode||this.isUsingFilteredPersons&&this.isMacroMode;
}

get _fleetModuleElement(){
return this.__fleetModuleElement||(this.__fleetModuleElement=this._elementService.selectElement('.fleet-module'));
}

get _moduleHeaderElement(){
return this.__moduleHeaderElement||(this.__moduleHeaderElement=this._fleetModuleElement.find('.module-header'));
}

_recalculateDimensions(){
this._$timeout(()=>{
const{width:moduleWidth,height:moduleHeight}=this._fleetModuleElement[0].getBoundingClientRect();
const{height:moduleHeaderHeight}=this._moduleHeaderElement[0].getBoundingClientRect();
const breadcrumbsHeight=this.selectedGroupData.id===null?0:BreadcrumbsHeight;

this._updateHeatmapDimensions(moduleWidth,moduleHeight-moduleHeaderHeight-breadcrumbsHeight);
this._updatePersonAreaHeight();
this._updatePersonAndGroupDimensions();
this._updateBreadcrumbs();

if(this._personsTilesAreVisible){
this._updateNameVisibility();
}else{
this._updateGroupThresholdStatusBars();
}

this.isInitiallyLoading=!1;
});
}

_updateHeatmapDimensions(width,height){
if(this._heatmapDimensions&&
this._heatmapDimensions.width===width&&
this._heatmapDimensions.height===height){
return;
}

this._heatmapDimensions={width,height};
this.heatmapDimensionsAsCSS=_jsonStyleToCss(this._heatmapDimensions);
}

_updatePersonAreaHeight(){
const maxAvailableDepth=this._heatmapService.getMaxAvailableDepth(this._heatmapViewModel);
const headerHeight=maxAvailableDepth===2?
DirectGroupHeaderHeight+SubGroupHeaderHeight:
DirectGroupHeaderHeight;

const newPersonAreaHeight=this._heatmapDimensions.height-headerHeight-DefaultPersonAreaPaddingTop;
if(newPersonAreaHeight===this._personAreaHeight){
return;
}

this._personAreaHeight=newPersonAreaHeight;
}

_updatePersonNameVisibility(longestPersonName,{height,width}){
this.hidePersonNames=width<MinimumPersonWidthToDisplayNames||height<MinimumPersonHeightToDisplayNames;
this.useShortPersonNames=this.hidePersonNames===!1&&
_.exists(longestPersonName)&&
getTextWidth(_replaceWithFixedChar(longestPersonName),PersonFont)>=width;
}

_updateGroupNameVisibility(personWidth){
let subGroupsShortDetermined=!1;
let topLevelShrinkDetermined=!1;
let topLevelShortDetermined=!1;
for(const topLevelChild of this._heatmapViewModel.children){
if(topLevelShrinkDetermined&&
subGroupsShortDetermined)break;

let numColSpans=0;
for(const subGroup of topLevelChild.children){
const subGroupColSpans=subGroup.colSpan||1;
numColSpans+=subGroupColSpans;

if(subGroup instanceof PseudoGroup)continue;

const colSpanWidth=subGroupColSpans*personWidth;
if(!subGroupsShortDetermined&&
colSpanWidth<getTextWidth(_replaceWithFixedChar(subGroup.name),SubHeaderFont)){
subGroupsShortDetermined=!0;
}
}

if(topLevelShrinkDetermined)continue;

const realColSpans=_.max([numColSpans,topLevelChild.colSpan])||1;
const topLevelAvailableWidth=realColSpans*personWidth+(realColSpans-1)*DefaultPersonHorizontalSpacing;
if(topLevelAvailableWidth<MinimumTopLevelWidthToDisplayLargeNames){
topLevelShortDetermined=!0;
topLevelShrinkDetermined=!0;
}else if(!topLevelShortDetermined&&
topLevelAvailableWidth<getTextWidth(topLevelChild.name,TopLevelHeaderFont)){
topLevelShortDetermined=!0;
}
}

this.shrinkTopLevelNames=topLevelShrinkDetermined;
this.useShortGroupNames=subGroupsShortDetermined;
this.useShortTopLevelNames=topLevelShortDetermined;
}

_updateNameVisibility(){
const namesByDepth=this._heatmapService.getLongestNamesByDepth(this._heatmapViewModel);

this._updatePersonNameVisibility(namesByDepth.person,this._singlePersonStyle);
this._updateGroupNameVisibility(this._singlePersonStyle.width);
}

_getPersonHeight(){
if(this.personAreaHeight<MinPersonHeight){
return{personHeight:void 0,personVerticalSpacing:void 0};
}

let personHeight=DefaultPersonHeight;
let personVerticalSpacing=DefaultPersonVerticalSpacing;

while(this.personAreaHeight<personHeight){
personVerticalSpacing=personVerticalSpacing/2;
personHeight=personHeight/2;
}

return{personHeight,personVerticalSpacing};
}

_updatePersonAndGroupDimensions(){
const{personHeight,personVerticalSpacing}=this._getPersonHeight();

const personHeightWithMargin=personHeight+personVerticalSpacing;
if(!_.exists(personHeight)||personHeightWithMargin>this.personAreaHeight){
_warnNotEnoughSpace(this.personAreaHeight,personHeightWithMargin);
this.isUsingFilteredPersons=!1;
this.isMacroMode=!0;
return;
}

const{leafColSpans,filteredLeafColSpans}=this._heatmapService.determineColSpansForLeafGroups(this._heatmapViewModel,
personHeightWithMargin,
this.personAreaHeight,
this._filteredPersonIds);

const numLeafColumns=leafColSpans.reduce((sum,n)=>sum+(n||1),0);
const numFilteredLeafColumns=filteredLeafColSpans.reduce((sum,n)=>sum+(n||1),0);

const marginBetweenGroupColumns=DefaultDirectGroupMargin;
const personHorizontalSpacing=DefaultPersonHorizontalSpacing;

const numTopLevelGroups=this._heatmapViewModel.children.length||1;

const totalTopLevelGroupHorizontalPaddingWidth=numTopLevelGroups*(TopLevelGroupHorizontalPadding*2-personHorizontalSpacing);

const totalGroupMarginWidth=(numTopLevelGroups-1)*marginBetweenGroupColumns;
const availableHeatmapWidth=this._heatmapDimensions.width-totalGroupMarginWidth-totalTopLevelGroupHorizontalPaddingWidth;

const personUnitWidth=Math.min(availableHeatmapWidth/numLeafColumns,DefaultPersonWidth);
const personWidthUnfiltered=personUnitWidth-personHorizontalSpacing;

const personUnitWidthFiltered=Math.min(availableHeatmapWidth/numFilteredLeafColumns,DefaultPersonWidth);
const personWidthFiltered=personUnitWidthFiltered-personHorizontalSpacing;

let personWidth;
if(personWidthUnfiltered>=MinPersonWidth){
personWidth=personWidthUnfiltered;
this._personUnitWidth=personUnitWidth;
this._heatmapService.setColSpansForLeafGroups(this._heatmapViewModel,leafColSpans);

this.isUsingFilteredPersons=!1;
this.isMacroMode=!1;
}else if(personWidthUnfiltered!=personWidthFiltered&&personWidthFiltered>=MinPersonWidth){
personWidth=personWidthFiltered;
this._personUnitWidth=personUnitWidthFiltered;
this._heatmapService.setColSpansForLeafGroups(this._heatmapViewModel,filteredLeafColSpans);

this.isUsingFilteredPersons=!0;
this.isMacroMode=!0;
}else{
this.isUsingFilteredPersons=!1;
this.isMacroMode=!0;
return;
}

const newTooltipLeftMargin=personWidth/2-TooltipWidth/2;
if(newTooltipLeftMargin!==this.tooltipLeftMargin){
this.tooltipLeftMargin=newTooltipLeftMargin;
}

const newPersonStyle={width:personWidth};
if(personHeight!==DefaultPersonHeight){
newPersonStyle.height=personHeight;
}







if(personVerticalSpacing!==DefaultPersonVerticalSpacing){
newPersonStyle.marginBottom=personVerticalSpacing;
}

if(_.isEqual(newPersonStyle,this._singlePersonStyle)){
return;
}

this._singlePersonStyle=newPersonStyle;
this.singlePersonCSS=_jsonStyleToCss(newPersonStyle);
}

getMacroModeStatusHeightsFor(group){
const persons=group.aggregatePersons||group.directPersons;
const{
At=[],
Above=[]}=
_.groupBy(persons,p=>p.thresholdStatusFor(this.selectedNotificationType,p).value);

const personUnitHeight=this.heatmapDimensions.height/this._heatmapService.getMaxNumPersonsInLeafGroups(this._heatmapViewModel);

const numRest=persons.length-Above.length-At.length;
const statusHeights={
above:Above.length*personUnitHeight,
at:At.length*personUnitHeight,
below:numRest*personUnitHeight};


if(personUnitHeight<MinMacroModePersonHeight){
if(statusHeights.above>0&&statusHeights.above<MinMacroModePersonHeight){
statusHeights.above=MinMacroModePersonHeight;
}
if(statusHeights.at>0&&statusHeights.at<MinMacroModePersonHeight){
statusHeights.at=MinMacroModePersonHeight;
}
}

const totalBarsHeight=statusHeights.above+statusHeights.at+statusHeights.below;
if(totalBarsHeight>this.heatmapDimensions.height){
statusHeights.below=this.heatmapDimensions.height-(statusHeights.above+statusHeights.at);
}else if(totalBarsHeight<MinMacroModeGroupHeight){
const atHasHeight=statusHeights.at>0;
const aboveHasHeight=statusHeights.above>0;
const belowHasHeight=statusHeights.below>0;

const numBarsWithHeight=_.compact([atHasHeight,aboveHasHeight,belowHasHeight]).length;
const extraPixelsToDistribute=(MinMacroModeGroupHeight-totalBarsHeight)/numBarsWithHeight;

statusHeights.at+=atHasHeight?extraPixelsToDistribute:0;
statusHeights.above+=aboveHasHeight?extraPixelsToDistribute:0;
statusHeights.below+=belowHasHeight?extraPixelsToDistribute:0;
}

return statusHeights;
}

_updateGroupThresholdStatusBars(){
if(this.isMacroMode===!1){
return;
}

const leafGroups=this._heatmapService.getLeafGroups(this.heatmapViewModel);

this.macroModeGroupInfo=leafGroups.map(group=>{
const{at,above,below}=this.getMacroModeStatusHeightsFor(group);

return{
id:group.id,
name:group.name,
parentGroupName:group.parentGroupName,
parentGroupId:group.parentGroupId,
statusBarStyles:{
at:{height:at},
above:{height:above},
below:{height:below}}};


}).reverse();
}

getWidthForCols(numCols){
return this._personUnitWidth*numCols;
}

getPersonPlaceholderDisplayName(){
return this.useShortPersonNames===!0?'--':'Empty';
}

getDisplayNameFor(personOrGroup,isTopLevel=!1){
let useShort;
if(personOrGroup instanceof PersonStatisticsViewModel){
useShort=this.useShortPersonNames;
}else if(isTopLevel===!0){
useShort=this.useShortTopLevelNames;
}else{
useShort=this.useShortGroupNames;
}

return useShort===!0?this._memoizedHeatmapShortName(personOrGroup):personOrGroup.name;
}

get heatmapViewModel(){
return this._heatmapViewModel;
}

get personAreaHeight(){
return this._personAreaHeight;
}

get heatmapDimensions(){
return this._heatmapDimensions;
}

get singlePersonStyle(){
return this._singlePersonStyle;
}

get directGroups(){
return this._directGroups;
}

get _lastFetchTime(){
return tryGet(this,'dashboardDataService.lastFetchTime').
then(t=>t.getTime()).
otherwise(null);
}};


function _replaceWithFixedChar(str){
return'M'+str.replace(/[a-z]/g,'e');
}

const _jsonStyleToCss=styleObj=>JSON.stringify(styleObj).replace(/,/g,'px;').replace(/[{}"]+/g,'')+'px';

function _warnNotEnoughSpace(areaHeight,personHeightWithMargin){
console.warn(`Not enough space to draw people... bailing! PersonAreaHeight: ${areaHeight}, PersonHeightWithMargin: ${personHeightWithMargin}`);
}

module.exports=DashboardHeatmapDirective;
//# sourceMappingURL=dashboardHeatmapDirective.js.map
